/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useState } from 'react';
import GetPayHistoryActionBox from '../ActionIcons/GetPayHistoryActionBox/GetPayHistoryActionBox';
import './tables_styles.css';
import EmployeeNamePic from '../EmployeeNamePic/EmployeeNamePic';
import WarningARModalController from '../../Modals/ActionRequiredModals/WarningARModal/WarningARModalController';
import { useAppSelector } from '../../../infra/hooks';
import _ from 'lodash';
import { useTranslate } from '../../../hooks';
import { arabicDataGrid, baseDateFormatting } from '../../helper';
import { DateField } from '../../../components';

interface Propval {
  trans: any;
}

const Warning = ({ trans }: Propval) => {
  const [openModal, setOpenModal] = useState(false);
  const [fullData, setFullData] = useState<any>({});

  const storedARData = useAppSelector(
    (state) => state.actionRequiredSlice.actionRequiredData,
  );

  const handleTransferView = (transfer: any) => {
    setFullData(transfer);
  };

  const tableColumns: any = [
    {
      field: 'appliedOn',
      headerName: trans('Applied On'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => (
        <DateField value={params?.row?.appliedOn} format={baseDateFormatting} />
      ),
    },
    {
      field: 'warningBy',
      headerName: trans('Warning By'),

      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        return (
          <EmployeeNamePic
            name={params?.row?.warning_by_name}
            picture={params?.row?.to_profile_pic}
          />
        );
      },
    },
    {
      field: 'warningTo',
      headerName: trans('Warning To'),

      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        return (
          <EmployeeNamePic
            name={params?.row?.empName}
            picture={params?.row?.empPic}
          />
        );
      },
    },
    {
      field: 'description',
      headerName: trans('Description'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },

    {
      field: 'action',
      flex: 1,
      headerName: trans('Action'),
      headerClassName: 'header',
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: any) => {
        return (
          <GetPayHistoryActionBox
            onView={() => {
              handleTransferView(params?.row?.fullData);
              setOpenModal(true);
            }}
          />
        );
      },

      width: 200,
      height: 70,
    },
  ];

  const row_data = _.map(storedARData, (data: any) => {
    return {
      id: data?.id,
      empId: `#${data?.staff_id}`,
      empName: `${data?.first_name} ${data?.last_name}`,
      empPic: data?.profile_pic,
      to_profile_pic: data?.to_profile_pic,
      warning_by_name: `${data?.warning_by_first_name} ${data?.warning_by_last_name}`,
      appliedOn: data?.warning_date,
      description: data?.subject,
      fullData: data,
    };
  });

  const { isRTL } = useTranslate();

  return (
    <>
      <Box
        className="ar_table"
        sx={{
          '& .header': {
            backgroundColor: '#F5F5F5',
          },

          width: '100%',
          marginTop: '2em',
        }}
      >
        <DataGrid
          sx={{
            color: '#081735',
            font: 'normal normal normal 14px/24px Lato;',
          }}
          autoHeight
          disableColumnMenu
          localeText={isRTL ? arabicDataGrid : undefined}
          disableExtendRowFullWidth
          disableSelectionOnClick
          rows={row_data}
          columns={tableColumns}
          componentsProps={{
            pagination: {
              labelRowsPerPage: trans('Rows per page'),
            },
          }}
        />
      </Box>
      {openModal && (
        <WarningARModalController
          closeModal={() => setOpenModal(false)}
          isModalOpen={openModal}
          fullData={fullData}
        />
      )}
    </>
  );
};

export default Warning;
